import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getNewPasswordSchema } from "@/entities/new-password-form";
import { appRouterPaths } from "@/services/navigation";
import { useRecoveryChangePasswordMutation } from "@/services/api";
import { useAppSelector } from "@/services/store";
import type { NewPasswordFormValues } from "@/entities/new-password-form";
import { passwordRecoveryActions, passwordRecoverySelectors } from "../password-recovery-slice";
import { PasswordRecoverySteps } from "../types";

export const useNewPasswordForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mobilePhone = useAppSelector(passwordRecoverySelectors.selectMobilePhone);

  const [changePassword, { isLoading }] = useRecoveryChangePasswordMutation();

  const formApi = useForm({
    resolver: yupResolver(getNewPasswordSchema()),
  });

  const handleSubmit = (data: NewPasswordFormValues) => {
    if (!mobilePhone) {
      return;
    }

    changePassword({ newPassword: data.password, mobilePhone })
      .unwrap()
      .then(() => {
        dispatch(passwordRecoveryActions.resetState());
        dispatch(passwordRecoveryActions.setStep(PasswordRecoverySteps.SUCCESS_STEP));
      })
      .catch((error) => {
        formApi.setError("password", { message: error.message });
      });
  };

  const handleCancel = () => {
    dispatch(passwordRecoveryActions.resetState());
    navigate(appRouterPaths.logIn);
  };

  const submitDisabled = !formApi.formState.isValid;

  return {
    formApi,
    handleSubmit,
    handleCancel,
    submitDisabled,
    isLoading,
  };
};
